<template>
  <div class="vbox-container" :class="params.className" :style="{padding:params.padding}" ref="ct">
    <div class="handler"></div>
    <div class="vbox-row-ct">
      <div class="vbox-row dragula-container" ref="rows"

           v-for="(row,index) in params.rows" :key="index">

      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name:"hbox-designer",
    props:{
      params:Object
    },
    data(){
      return {}
    },
    mounted() {
      let me=this;
      me.params.rows.forEach((row,index)=>{
        if(row.items){
          // let el=$(me.$el).find(".vbox-row").eq(index)[0];
          let el=me.$refs.rows[index]
          me.$emit("addItems",row.items,el);
        }
      });
    },
    methods:{
      setContainerData(ct,items,data){
        let index=$(ct).index();
        data.rows[index].items=items;
      }
    },
    watch:{
      "params.style":{
        immediate: true,
        handler(v){
          this.$nextTick(()=>{

          $(this.$refs.ct).attr("style",`${v} ; padding:${this.params.padding}`)
          })
        }
      },
      "params.rows":{
        deep:true,
        immediate: true,
        handler:function(newValue){
          this.$nextTick(() => {
            newValue.forEach((row, index) => {
              let div=this.$refs.rows[index];
              let style=`${(row.style || "")} ; height:${row.height};padding-top:${(row.paddingTop || 0)};padding-bottom:${(row.paddingBottom || 0)}`;
              $(div).attr("style",style);
            });
          });
        }
      }
    }
  }
</script>
<style scoped>
  .vbox-container{
    height:calc(100% - 4px);
  }
.dragula-container{
  /*display: inline-block;*/
  border: solid 1px #aaa;
  /*height:calc(100% - 15px);*/
  overflow:auto;
  min-width:30px;
}
.handler{
  cursor:move;
  background-color:#9e9e9e;
  height:15px;
  border:1px solid #aaa;
}

  .designer-active>.handler{
    background-color:#607D8B
  }
  .vbox-row-ct{
    height:calc(100% - 15px);
  }
</style>



// WEBPACK FOOTER //
// src/common/components/extend/layout/designer/vbox-designer.vue